/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  SvgIcon
} from "../"

export const SearchResultsFeedback = (props) => {
  return (
    <div className="slds-p-around_medium slds-p-left_x-large slds-p-right_x-large filter-bar">
      <div className={`filter-bar_result-${props.resultsFound ? 'positive' : 'negative'} slsd-in slds-show_inline-block`}>
        <b>
          {`${props.resultsFound ? props.numberOfResults : 'No'} results for “${props.searchString}"${props.filter ? ` in "${props.filter}"` : ''}.`}
        </b>
      </div>
      {props.removeFilter
        ? <div className="slds-show_inline-block slds-m-left_large" onClick={props.onRemoveFilterClick}>
            <SvgIcon
              variant="utility"
              symbol="close"
              size="xx-small"
              buttonIcon={true}
            />
            <span className="slds-align-middle slds-m-left_xx-small">
              Remove filter
            </span>
          </div>
        : <span></span>
      }
    </div>
  )
}

SearchResultsFeedback.propTypes = {
  resultsFound: PropTypes.bool.isRequired,
  numberOfResults: PropTypes.number.isRequired,
  searchString: PropTypes.string.isRequired,
  filter: PropTypes.string,
  removeFilter: PropTypes.bool,
  onRemoveFilterClick: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/components/search-results-feedback/index.js